export const strings = {
    "saveBtnTooltip": "Aggiungi al carrello",
    "deleteAllBtnTooltip": "Svuota il carrello",
    "deleteBtnTooltip": "Elimina dal carrello",
    "relatedProductsTitle": "Guarda anche:"
}